import { Content } from '@orobix/orobix-fe-components'

import { PageHeader } from '../../components/PageHeader/PageHeader'
import { withQueryErrorBoundary } from '../../components/QueryErrorBoundary/withQueryErrorBoundary'
import { OptimizationProcessesActionsButton } from './OptimizationProcessesActionsButton'
import { OptimizationProcessesList } from './OptimizationProcessesList/OptimizationProcessesList'

export const OptimizationProcessesRoot = withQueryErrorBoundary(() => (
  <Content>
    <PageHeader title="" right={<OptimizationProcessesActionsButton />} />

    <OptimizationProcessesList />
  </Content>
))
